import toolsClient from "@/api/toolsClient";

export const hasData = async (id) => {
  const { data } = await toolsClient.get(`accounts/${id}/hasFinancialData`);

  return data.hasFinancialData;
};

export const getData = async (id, type, params) => {
  const { data } = await toolsClient.get(`accounts/${id}/revenue/${type}`, { params });

  return data.slice().reverse();
};

export const getPodcastRevenue = async (id, type, params) => {
  const { data } = await toolsClient.get(`accounts/${id}/revenue/podcasts/${type}`, { params });

  return data;
};

export const getPodcastRevenueByPodcast = async (id, params) => {
  const { data } = await toolsClient.get(`accounts/${id}/revenue/podcasts`, { params });

  return data;
};

export const updateInvoiceSettings = async (invoiceData) => {
  const { data } = await toolsClient.post(
    `/accounts/invoiceSettings`,
    invoiceData
  );

  return data;
};

export const getInvoiceSettings = async (id) => {
  const { data } = await toolsClient.get(`/accounts/invoiceSettings/${id}`);

  return data;
};
